export const bpfrpt_proptype_WindowScroller = 0